<template>
  <v-container>

    <NavBar :step="1" />

    <Titulo></Titulo>


    <br v-if="screen < 800">
    <br>


    <v-stepper v-model="e1" elevation="0">
      <v-stepper-header>
        <div class="circle-step">
          <v-stepper-step class="stepForms" style="flex-direction: column;" :color="stepperColor" :complete="e1 > 1"
            step="1"> Inicio
          </v-stepper-step>
        </div>
        <v-divider></v-divider>
        <div class="circle-step">
          <v-stepper-step style="flex-direction: column;" :color="stepperColor" :complete="e1 > 2" step="2"> Mascota
          </v-stepper-step>
        </div>
        <v-divider></v-divider>
        <div class="circle-step2">
          <v-stepper-step style="flex-direction: column;" :color="stepperColor" :complete="e1 > 3" step="3"> Plan
          </v-stepper-step>
        </div>
        <v-divider></v-divider>
        <div class="circle-step2">
          <v-stepper-step style="flex-direction: column;" :color="stepperColor" step="4"> Datos </v-stepper-step>
        </div>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="2">
          <v-form ref="form" v-model="valid">
            <v-container style="justify-content: center; display: flex; flex-direction: column; align-items: center;">
              <div class="form-container">

                <v-col style="max-width: 300px">
                  <h3 class="text-center"
                    style="font-family: Helvetica; font-style: normal; font-weight: 700; font-size: 18px; line-height: 15px; letter-spacing: -0.01em; color: #002C77;">
                    Cuéntanos sobre tu mascota</h3>

                  <h4 class="text-center"
                    style="font-family: Helvetica; font-style: normal; font-weight: 400; font-size: 13px; line-height: 16px; color: #232323; opacity: 0.75; padding: 2%;">
                    Selecciona una opción</h4>

                  <v-col>
                    <v-radio-group required v-model="petData.species" v-on:change="getBreeds()" @change="change()">
                      <v-radio v-for=" (option, index) in speciesOptions" :key="option.id" :value="option"
                        :class="mascotaVista" off-icon on-icon>
                        <template v-slot:label>
                          <div :class="vistaBreeds">
                            <img width="130px" :alt="option.name" :src="option.image" class="species-icon" />
                            <br>
                            <label style="margin:auto;" v-if="index == 0">Perro</label>
                            <v-radio-group v-if="index == 0" v-model="petSelect">
                              <v-radio v-model="selecPPet" style="margin: auto;"></v-radio>
                            </v-radio-group>
                            <label style="margin:auto;" v-if="index == 1">Gato</label>
                            <v-radio-group v-if="index == 1" v-model="catSelect">
                              <br>
                              <v-radio v-model="selecPPet" style="margin: auto;"></v-radio>
                            </v-radio-group>
                          </div>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </v-col>

                  <div v-if="petData.species">

                    <v-col>
                      <v-text-field v-model="petData.petName" maxlength="51" :rules="nameRules"
                        label="Ingresa el nombre de tu mascota" @change="change()" required solo filled
                        class="v-textField">
                      </v-text-field>
                    </v-col>

                    <br>

                    <v-col>
                      <v-select :disabled="!petData.species" :items="breeds" v-model="petData.breed" :rules="breedRules"
                        return-object @change="change()" item-text="name" label="Selecciona la raza" required solo
                        filled class="v-textField">
                      </v-select>
                    </v-col>

                    <br>

                    <v-col>
                      <v-select :items="ages" v-model="petData.age" :rules="ageRules" :loading="loadingAges"
                        return-object @change="change()" :disabled="loadingAges" item-text="label"
                        label="Selecciona la edad de tu mascota" required solo filled class="v-textField">
                      </v-select>
                    </v-col>

                    <br>

                    <v-col>
                      <v-select :items="sexOptions" v-model="petData.sex" :rules="sexRules" item-text="label"
                        @change="change()" return-object label="Selecciona el géreno de tu mascota" required solo filled
                        class="v-textField">
                      </v-select>
                    </v-col>

                    <br>

                    <v-col class="d-flex flex-column align-center">
                      <h3 class="text-center"
                        style="font-family: Helvetica; font-style: normal; font-weight: 700; font-size: 18px; line-height: 15px; letter-spacing: -0.01em; color: #002C77;">
                        ¿Tiene microchip?
                      </h3>

                      <h4 class="text-center"
                        style="font-family: Helvetica; font-style: normal; font-weight: 400; font-size: 13px; line-height: 16px; color: #232323; opacity: 0.75; padding: 2%;">
                        No influye en el seguro, pero nos ayuda a recomendarte coberturas y servicios
                      </h4>

                      <v-radio-group autofocus @change="change()" v-model="petData.hasMicrochip" :rules="confirmRules"
                        required row class="d-flex justify-center">
                        <v-radio value="true">
                          <template v-slot:label>
                            <div class="forecast-selector">Sí</div>
                          </template>
                        </v-radio>

                        <v-radio value="false">
                          <template v-slot:label>
                            <div class="forecast-selector">No</div>
                          </template>
                        </v-radio>
                      </v-radio-group>
                    </v-col>


                    <v-col>

                      <div class="button-container">
                        <v-btn
                          style="background-color: rgba(0, 44, 119, 1); color: white; border-radius: 12px; width: 100%; height: 120%; margin: auto;"
                          @click="validate()">
                          Continuar
                        </v-btn>
                      </div>

                    </v-col>

                  </div>

                </v-col>
              </div>
            </v-container>
          </v-form>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

  </v-container>
</template>

<script>
import catIcon from "@/assets/images/catt2.png";
import dogIcon from "@/assets/images/dogg.png";

import catIcon2 from "@/assets/images/catt.png";
import dogIcon2 from "@/assets/images/dogg2.png";

import BreedsService from "../services/breeds.service";
import AgeService from "../services/age.service";
import ShieldService from "../services/shield.service";

import Titulo from "../components/Titulo.vue";
import NavBar from "@/components/NavBar.vue";

import CryptoJS from 'crypto-js';

import Vue from "vue";
import { VueReCaptcha } from 'vue-recaptcha-v3'
const { VUE_APP_RECAPTCHA3_SITE_KEY } = process.env;
Vue.use(VueReCaptcha, { siteKey: VUE_APP_RECAPTCHA3_SITE_KEY })

export default {
  name: "DetailForm",
  components: { Titulo, NavBar },
  data: () => ({
    secretKey: process.env.VUE_APP_CRYPT,
    stepperColor: '#00968F',
    petSelect: true,
    catSelect: true,
    valid: false,
    e1: 2,
    userData: {
      name: null,
      surname: null,
      serialNumber: null,
      rut: null,
      region: null,
      commune: null,
      regionCode: null,
      comuneCode: null,
      address: null,
      addressNumber: null,
      addressDepto: null,
      email: null,
      phoneNumber: null,
      couponId: null,
      dates: null,
      day: null,
      month: null,
      year: null,
      stepId: null,
      coverType: null,
    },
    servicesData: {
      stepId: null,
      contactID: null,
      type: 'update',
    },
    petData: {
      species: null,
      breed: null,
      breedCode: null,
      petName: null,
      age: null,
      sex: null,
      hasMicrochip: false,
    },
    screen: window.screen.width,
    vistaBreeds: '',
    sexOptions: [
      {
        id: "male",
        label: "Macho",
      },
      {
        id: "female",
        label: "Hembra",
      },
    ],
    selecPPet: false,
    breedRules: [(v) => !!v || "Necesitamos saber la raza de tu mascota"],
    nameRules: [
      (v) => !!v || "El nombre es requerido",
      (v) => !/^[0-9]*$/.test(v) || "Ingrese solo letras",
      (v) => (!!v && v.length <= 50) || "Debe ingresar máximo 50 caracteres"
    ],
    ageRules: [(v) => !!v || "Debes indicar la edad de tu mascota"],
    sexRules: [(v) => !!v || "Selecciona el sexo de tu mascota"],
    microchipRules: [
      (v) => !!v || "Tu mascota debe tener microchip para contratar el seguro",
    ],
    selectedSpecies: null,
    breeds: [],
    speciesOptions: [
      {
        id: "dog",
        name: "Perro",
        image: dogIcon2,
      },
      {
        id: "cat",
        name: "Gato",
        image: catIcon2,
      },
    ],
    ages: [],
    loadingAges: false,
  }),
  async mounted() {

    const query = this.$route.query;
    const petDataAux = localStorage.getItem('petData');
    const userDataAux = localStorage.getItem('userData');
    const servicesDataAux = localStorage.getItem('servicesData');

    this.getAges();

    if (query.stepID) {

      const abandoned = await ShieldService.newGetStepAbandoned(query.stepID);

      this.userData = abandoned.userData;
      this.petData = abandoned.petData;
      this.servicesData.stepId = abandoned._id;
      this.servicesData.type = 'update';

      const userDataLocal = JSON.stringify(this.userData);
      const servicesDataLocal = JSON.stringify(this.servicesData);
      const petDataLocal = JSON.stringify(this.petData);

      const encryptedUserDataLocal = CryptoJS.AES.encrypt(userDataLocal, this.secretKey).toString();
      const encryptedServicesDataLocal = CryptoJS.AES.encrypt(servicesDataLocal, this.secretKey).toString();
      const encryptedPetDataLocal = CryptoJS.AES.encrypt(petDataLocal, this.secretKey).toString();

      localStorage.setItem('userData', encryptedUserDataLocal);
      localStorage.setItem('servicesData', encryptedServicesDataLocal);
      localStorage.setItem('petData', encryptedPetDataLocal);

    } else if (petDataAux) {
      const bytesPetData = CryptoJS.AES.decrypt(petDataAux, this.secretKey);
      const decryptedDataPet = bytesPetData.toString(CryptoJS.enc.Utf8);
      this.petData = JSON.parse(decryptedDataPet);
      // console.log("petData: ", this.petData);

      const bytesUserData = CryptoJS.AES.decrypt(userDataAux, this.secretKey);
      const decryptedDataUser = bytesUserData.toString(CryptoJS.enc.Utf8);
      this.userData = JSON.parse(decryptedDataUser);
      // console.log("userData: ", this.userData);

      const bytesServicesData = CryptoJS.AES.decrypt(servicesDataAux, this.secretKey);
      const decryptedServicesData = bytesServicesData.toString(CryptoJS.enc.Utf8);
      this.servicesData = JSON.parse(decryptedServicesData);
      // console.log("servicesData: ", this.servicesData);

    } else {
      const petDataLocal = JSON.stringify(this.petData);
      const encryptedPetDataLocal = CryptoJS.AES.encrypt(petDataLocal, this.secretKey).toString();
      localStorage.setItem('petData', encryptedPetDataLocal);

      const bytesUserData = CryptoJS.AES.decrypt(userDataAux, this.secretKey);
      const decryptedDataUser = bytesUserData.toString(CryptoJS.enc.Utf8);
      this.userData = JSON.parse(decryptedDataUser);
      // console.log("userData: ", this.userData);

      const bytesServicesData = CryptoJS.AES.decrypt(servicesDataAux, this.secretKey);
      const decryptedServicesData = bytesServicesData.toString(CryptoJS.enc.Utf8);
      this.servicesData = JSON.parse(decryptedServicesData);
      // console.log("servicesData: ", this.servicesData);
    }

    this.getBreeds();

    if (this.screen > 800) {
      this.mascotaVista = 'mascota';
      this.vistaBreeds = 'vistaBreeds';
    } else {
      this.mascotaVista = 'mascota2';
      this.vistaBreeds = 'vistaBreeds2';
    }
  },
  methods: {
    back() {
      this.$emit("back");
    },
    message() {
      this.$alert("El chip para tu mascota y posterior registro en www.registratumascota.cl, es un requisito para la ley N°21020 de Tenencia Responsable o Ley Cholito. No olvides realizar este proceso.", "Información", "info")
    },
    validate() {
      if (this.$refs.form.validate()) {

        const petDataLocal = JSON.stringify(this.petData);
        const encryptedPetDataLocal = CryptoJS.AES.encrypt(petDataLocal, this.secretKey).toString();
        localStorage.setItem('petData', encryptedPetDataLocal);

        if (this.screen > 800) {
          this.$router.push({ path: '/planEscritorio' })
        } else {
          this.$router.push({ path: '/planMovil' })
        }
      }
    },
    async getBreeds() {
      if (this.petData.species) {
        // this.petData.breed = null;
        const data = await BreedsService.getBreeds(this.petData.species.id);

        // Transforma la estructura a un array plano para el v-select
        this.breeds = data.flatMap(category => category);

        if (this.petData.species.id == 'dog') {
          this.speciesOptions[0].image = dogIcon
          this.speciesOptions[1].image = catIcon2
          this.petSelect = false
          this.catSelect = true
        } else if (this.petData.species.id == 'cat') {
          this.speciesOptions[0].image = dogIcon2
          this.speciesOptions[1].image = catIcon
          this.petSelect = true
          this.catSelect = false
        }
      }
    },
    async getAges() {
      this.loadingAges = true;
      this.ages = await AgeService.getAges();
      this.loadingAges = false;
    },
    async change() {

      // reCaptcha v3 token
      await this.$recaptchaLoaded();
      const tokenStep = await this.$recaptcha('captchaToken');

      try {
        await ShieldService.newCreateStep(null, this.petData, null, this.servicesData, 'Mascotas', tokenStep);
      } catch (error) {
        console.log("Cart Fail");
      }
    },
  }
};

</script>
<style lang="scss">
.mascota {
  width: 100%;
  margin-left: 2%;
  color: white;
}

.mascota2 {
  width: 100%;
  margin-left: -6%;
  color: white;
}

.vistaBreeds {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: -40%;
}

.vistaBreeds2 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: -20%;
}

.v-textField {
  box-sizing: border-box;
  min-height: 57px;
  margin: auto;
  background: #FFFFFF;
  border: 1.5px solid rgba(142, 142, 142, 0.2);
  box-shadow: 0px 1.5px 15px -2.5px rgba(32, 32, 32, 0.08);
  border-radius: 6px;
}

.form-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.species-container {
  display: block;
  position: relative;
  text-align: center;
  // margin-bottom: 2rem;
  cursor: pointer;

  .species-selector {
    display: inline-block;
    position: relative;
    margin-bottom: 0.5rem;
    margin-right: 0.5rem;
    // padding: 0.5rem 1rem;
    transition: background-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
    // border: 1px solid #f5f5f5;
    cursor: pointer;

    .radio-input {
      padding: 0.5rem;
      display: flex;
      flex-direction: column;
      cursor: pointer;
    }

    &:hover {
      background-color: #f5f5f5;
    }

    &.active {
      background-color: #f5f5f5;
      box-shadow: 4px 4px 4px #c6c6c6;
    }

    input[type="radio"] {
      position: absolute;
      left: 0;
      opacity: 0;
      outline: none;
      z-index: -1;
    }

    .species-icon {
      height: 100px;
      cursor: pointer;
    }
  }
}

.v-col {
  text-align: left;
}

.v-input--radio-group--column .v-input--radio-group__input {
  flex-direction: row !important;
}

@media (max-width: 800px) {
  .form-container {
    flex-direction: column;
    align-items: center;
  }
}

html body div#app.v-application.v-application--is-ltr.theme--light div.v-application--wrap main.v-main div.v-main__wrap div.container header div div.desktop-header div.desktop-logo-container div a.router-link-active div i.v-icon.notranslate.mdi.mdi-chevron-left.theme--light {
  color: #002C77 !important;
}
</style>